// removed by extract-text-webpack-plugin
module.exports = {"container":"magazines_bD8NC","title":"magazines_ApYFB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Heade/components/MagazineTitleEditable/styles.scss
// module id = 1018
// module chunks = 1